// extracted by mini-css-extract-plugin
export default {"project_card":"Project_project_card__3L3v2","center":"Project_center__QaHQb"};